<img
    [src]="downloadUrl | async"
    alt="Profile Image"
    class="admin-instructor-card-thumbnail"
    loading="lazy"
    onerror="this.src='../../../assets/images/default-profile.jpg'"
>
